import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env.VITE_APP_SUPABASE_URL
const supabaseAnonKey = (import.meta as any).env.VITE_APP_SUPABASE_PUBLIC_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)